interface MissingPlayersProps {
  /** Localized heading for the block (e.g. "Missing players"), provided by the parent. */
  label: string;
  /** List of player names who are missing. */
  players: string[];
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function MissingPlayers({ label, players, className = '' }: MissingPlayersProps) {
  if (players.length === 0) {
    return null;
  }

  return (
    <div
      className={`flex flex-col gap-[4px] text-center font-robotoRegular font-normal ${className}`}
    >
      <span className="text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        {label}
      </span>
      <p className="text-[10px] leading-[12px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {players.join(', ')}
      </p>
    </div>
  );
}
